
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Attachment = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M18.6240799,13.3269856 L18.4280195,13.1491362 L18.2319592,13.3269856 L12.7500235,18.3289984 C11.9668898,19.0434273 10.9245577,19.4375253 9.81244143,19.4375253 C8.70254052,19.4375253 7.65910074,19.0434273 6.87596707,18.3289984 C5.25653081,16.8516362 5.25653081,14.446628 6.87596707,12.9692658 L14.3162908,6.18269651 C14.7859495,5.75323076 15.4117918,5.51677197 16.0775108,5.51677197 C16.7443375,5.51677197 17.3701799,5.75323076 17.8409462,6.18269651 C18.3106049,6.61115175 18.5698033,7.18208857 18.5698033,7.79041417 C18.5698033,8.39772927 18.3106049,8.96967659 17.8409462,9.39712133 L11.1837561,15.4702723 C11.0275725,15.6137644 10.8182199,15.6915734 10.5955751,15.6915734 C10.374038,15.6915734 10.1646854,15.6137644 10.0096095,15.4702723 C9.68505759,15.175204 9.68505759,14.6952129 10.0096095,14.3991342 L14.9033642,9.93370089 L13.7281098,8.86155228 L8.8343551,13.3269856 C7.86291488,14.2132008 7.8618072,15.6562057 8.83324741,16.5434314 C9.30401377,16.9718866 9.9298561,17.2083454 10.5955751,17.2083454 C11.2624018,17.2083454 11.8871364,16.9718866 12.3590105,16.5434314 L19.0162006,10.4692699 C20.6345291,8.99190776 20.6345291,6.58689957 19.0162006,5.10953739 C18.2319592,4.39409798 17.1885194,4 16.0786185,4 C14.9698253,4 13.9263855,4.39409798 13.1410365,5.10953739 L5.70071271,11.8981277 C3.43328041,13.9666369 3.43328041,17.3326379 5.69960502,19.401147 C6.79842908,20.4025601 8.2594663,20.9553078 9.81244143,20.9553078 C11.3654166,20.9553078 12.8264538,20.4025601 13.9252778,19.401147 L19.4083213,14.3991342 L19.6043816,14.2202743 L19.4083213,14.0414145 L18.6240799,13.3269856 Z"></path>
        </g>
      </g>
    </IconBase>);
};

Attachment.defaultProps = {
  title: 'Attachment',
};

export default Attachment;
